import {MainTabProps} from './MainTabProps.interface';
import {MobileMainTab} from './MobileMainTab';
import {PcMainTab} from './PcMainTab';

export function MainTab({isMobile, showBorder, ...props}: MainTabProps) {
  return (
    <>
      {isMobile && (
        <MobileMainTab {...props} showBorder={showBorder || false} />
      )}
      {!isMobile && <PcMainTab {...props} />}
    </>
  );
}
